<template>
  <div class="row no-wrap items-center" @click.stop>
    <span
      style="height: 40px"
      class="q-mr-sm"
      v-if="conf && conf.config && conf.config.prefix"
    >
      {{ conf.config.prefix }}
    </span>
    <q-input
      dense
      type="number"
      @input="handleInput"
      :value="value"
      filled
      @click.stop
      @keyup.stop
      label="请输入数字"
      class="q-ml-sm"
      :error="!!numberFormatError"
      :error-message="numberFormatError"
      style="min-width: 180px"
    />
    <span
      style="height: 40px; white-space: nowrap"
      class="q-ml-sm"
      v-if="conf && conf.config && conf.config.suffix"
    >
      {{ conf.config.suffix }}
    </span>
  </div>
</template>

<script>
import QuestionChoiceMixin from "./question-choice.mixin";
import { numberInputCheckRule } from "../rule/number-input-check.rule";
import { setTimeout } from "timers";
export default {
  mixins: [QuestionChoiceMixin],

  data() {
    return {
      numberFormatError: "",
    };
  },

  watch: {
    checked: {
      immediate: true,
      handler(ckd) {
        if (ckd) {
          setTimeout(() => {
            this.$nextTick(() => {
              this.handleInput(this.value);
            });
          }, 0);
        } else {
          setTimeout(() => {
            this.$nextTick(() => {
              this.numberFormatError = "";
            });
          }, 0);
        }
      },
    },
  },

  computed: {
    errorTextDict() {
      const { numberFormatError } = this;
      return {
        numberFormatError,
      };
    },
  },

  methods: {
    handleInput(value) {
      const { min, max, type } = this.conf.config;
      this.numberFormatError = "";
      if (isNaN(parseFloat(value))) {
        this.numberFormatError = "请输入正确的数字格式";
      } else {
        if (type === "int") {
          if (value.match(/\./)) {
            this.numberFormatError = "请输入整数";
          }
        }

        // 区间检测
        if (min !== undefined && parseFloat(value) < min) {
          this.numberFormatError = `不得小于${min}`;
        }
        if (max !== undefined && parseFloat(value) > max) {
          this.numberFormatError = `不得大于${max}`;
        }
      }
      if (!this.checked) {
        this.numberFormatError = "当前选项未选中，输入无效";
      }
      this.$emit("change", value);

      // 如果没有任何问题，进行规则校验
      if (!this.numberFormatError) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.numberFormatError = numberInputCheckRule(
              this.current,
              this.answerCache,
              value
            );
          });
        }, 100);
      }
    },
  },
};
</script>
